import React from 'react';
import InfluenceAnswers from './influence-answers';
import InfluenceFreeText from './influence-free-text';

class InfluenceQuestions extends React.Component {
    constructor(props) {
        super(props);


        this.state = {
            answers: new Array(this.props.questions.length + 1),
            freeText: '',
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(questionNumber, questionValue, freeText) {
        const answersArray = [...this.state.answers];

        const { onAnswerChange } = this.props;

        const intQuestionNumber = parseInt(questionNumber.substring(0), 10);
        const answer = { ...answersArray[intQuestionNumber] };

        if (questionValue !== null) answer.value = questionValue.target.value;
        if (freeText !== null) answer.freeText = freeText.target.value;

        answersArray[intQuestionNumber] = answer;

        this.setState({ answers: answersArray });

        onAnswerChange(answersArray);
    }

    render() {
        const {
            questions, freeTextMessage
        } = this.props;

        return (
            <div className="toch-survey__row">
                {questions.map((question) => {
                    return (
                        <div className="toch-survey__item" key={question.questionNumber}>
                            <div className="toch-survey__question">
                                <span className="toch-survey__question--number">{question.questionNumber}</span>
                                {question.questionText}
                            </div>
                            {
                                question.addRadioButtonAnswers &&
                                <div className="toch-survey__answer">
                                    <InfluenceAnswers
                                        questionNumber={question.questionNumber}
                                        handleChange={this.handleChange}
                                        answers={question.answers}
                                    ></InfluenceAnswers>
                                </div>
                            }
                            {
                                question.addTellUsMoreInput &&
                                <div className="toch-survey__answer--details">
                                    <InfluenceFreeText
                                        addFreeTextMessageLabel={question.addTellUsMoreLabel}
                                        freeTextMessage={freeTextMessage}
                                        handleChange={this.handleChange}
                                        questionNumber={question.questionNumber}
                                    ></InfluenceFreeText>
                                </div>
                            }
                        </div>
                    );
                })}
            </div>
        );
    }
}

export default InfluenceQuestions;
